import styleInject from '#style-inject';styleInject("@import\"./globals.css\";@import\"./style-replay.css\";\n")